import {fabric} from "fabric";
import {BackgroundMakerV2} from "@frontend/BackgroundMaker";

export function makeGradient(type, coords, gradientUnits = 'pixels', colorStops) {
  try {
    return new fabric.Gradient({
      type, coords, gradientUnits, colorStops,
    });
  } catch (e) {
    console.error(e)
  }
}

export function makeBackgroundColorRectangle(options, backgroundColorField) {
  const backgroundColorFieldOptions = JSON.parse(backgroundColorField.options);

  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = options.width;
  tempCanvas.height = options.height;
  const editor = new BackgroundMakerV2(tempCanvas);
  return new fabric.Rect({
    id: `${backgroundColorField.element_id}${backgroundColorField.id}`,
    fieldType: backgroundColorField.type,
    name: backgroundColorField.name,
    order: parseInt(backgroundColorFieldOptions["Order"]),
    top: 0,
    left: 0,
    selectable: false,
    evented: false,
    ...options,
    editor,
  });
}
